import service from '@/store/services/vendors/attachments-service';

const state = {
    list: {},
    attachment: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, attachment) => {
        state.attachment = attachment;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(attachment => {
                commit('SET_RESOURCE', attachment);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(attachment => {
                commit('SET_RESOURCE', attachment);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((attachment) => {
                commit('SET_RESOURCE', attachment);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((attachment) => {
                commit('SET_RESOURCE', attachment);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    upload ({ commit, dispatch }, { item, image }) {
        return service.upload(item, image)
            .then((url) => {
                commit('SET_URL', url);
            });
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    attachment: state => state.attachment,
    url: state => state.url,
    dropdown: (state) => {
        return state.list.map(attachment => ({
            id: attachment.id,
            path: attachment.path,
            description: attachment.description,
            attachment_type: attachment.attachment_type,
            attachment_id: attachment.attachment_id,
            attachment_type_id: attachment.attachment_type_id,
        }));
    }
};

const attachments = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default attachments;
